import { all } from "redux-saga/effects";
import app from "./app";
import fileDownloader from "./file-downloader";
import locations from "./locations";
import task from "./task";
import catalogue from "./catalogue";
import user from "./user";
import myProperties from "./my-properties";
import item from "./item";
import quote from "./quote";
import job from "./job";
import market from "./market";
import abn from "./abn";
import ads from "./ads";
import analytics from "./analytics";
import agentAnalytic from "./agent-analytic";
import agentRecommendation from "./agent-recommendation";
import ConnectedCustomers from "./connectedCustomers";

const sagas = function* sagas() {
  yield all([
    ads(),
    app(),
    fileDownloader(),
    locations(),
    user(),
    task(),
    item(),
    catalogue(),
    quote(),
    myProperties(),
    job(),
    market(),
    abn(),
    analytics(),
    agentAnalytic(),
    agentRecommendation(),
    ConnectedCustomers(),
  ]);
};

export default sagas;
